import React from 'react';

const AlertCircleIcon = ({ 
  size = 19, 
  color = "#A82121", 
  className = "", 
  ...props 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 19 19" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M9.5 19C4.26 19 0 14.75 0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0C12.0196 0 14.4359 1.00089 16.2175 2.78249C17.9991 4.56408 19 6.98044 19 9.5C19 12.0196 17.9991 14.4359 16.2175 16.2175C14.4359 17.9991 12.0196 19 9.5 19ZM9.5 18C10.6162 18 11.7215 17.7801 12.7528 17.353C13.7841 16.9258 14.7211 16.2997 15.5104 15.5104C16.2997 14.7211 16.9258 13.7841 17.353 12.7528C17.7801 11.7215 18 10.6162 18 9.5C18 7.33 17.19 5.35 15.86 3.85L3.85 15.85C5.40476 17.2372 7.41632 18.0027 9.5 18ZM9.5 1C7.24566 1 5.08365 1.89553 3.48959 3.48959C1.89553 5.08365 1 7.24566 1 9.5C1 11.67 1.81 13.64 3.15 15.14L15.15 3.14C13.5923 1.75883 11.5819 0.997353 9.5 1Z" 
      fill={color}
    />
  </svg>
);

export default AlertCircleIcon;